import { Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const WarrantyTitle = styled(Typography).attrs((props) => ({
  as: "h1",
  fontSize: 18,
  marginTop: props.subtitle ? { _: 1, tablet: 2 } : "",
  mb: 4,
  textAlign: "center",
  ...props.theme.extendWarranty.warrantyTitle,
}))`
  background: linear-gradient(
    transparent,
    ${(props) => props.theme.extendWarranty.warrantyTitle.bg}
  );
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 28% 1px;
  ${(props) => props.theme.mediaQueries.tablet`
     background-size: 10% 1px;
  `}
`
export const TextColored = styled(Typography).attrs((props) => ({
  color: props.theme.extendWarranty.textColor,
  ...props,
}))``

export const SectionTitle = styled(Typography)`
  color: ${(props) => props.theme.colors.grey[900]};
  font-size: 36px;
  font-weight: 400;
  line-height: 44px;
  padding: 32px 0;
  ${(props) => props.theme.mediaQueries.tablet`
    padding: 64px 0;
  `}
`
